import type { ClinicFieldKey, CustomFieldInputType } from "@/api/db/connection";

export const ClinicProfileFields: Record<
	ClinicFieldKey,
	{ name: string; label: string; inputType: CustomFieldInputType; initialValue: string }
> = {
	clinic_name: {
		name: "clinic_name",
		label: "Nome da clínica",
		inputType: "text",
		initialValue: "Clínica Dra. Rafaela",
	},
	doctor_name: {
		name: "doctor_name",
		label: "Nome da médica",
		inputType: "text",
		initialValue: "Rafaela Nicholls Ribeiro Freitas",
	},
	doctor_crm: {
		name: "doctor_crm",
		label: "CRM",
		inputType: "text",
		initialValue: "54796",
	},
	doctor_rqe: {
		name: "doctor_rqe",
		label: "RQE",
		inputType: "text",
		initialValue: "55737",
	},
	clinic_cnpj: {
		name: "clinic_cnpj",
		label: "CNPJ da clínica",
		inputType: "text",
		initialValue: "46.328.802/0001-26",
	},
	clinic_address: {
		name: "clinic_address",
		label: "Endereço da clínica",
		inputType: "text",
		initialValue: "Rua da Paisagem, 240, sala 5, Vila da Serra, Nova Lima/MG",
	},
	bank_name: {
		name: "bank_name",
		label: "Banco",
		inputType: "text",
		initialValue: "Banco Itaú",
	},
	bank_agency: {
		name: "bank_agency",
		label: "Agência bancária",
		inputType: "text",
		initialValue: "3072",
	},
	bank_account: {
		name: "bank_account",
		label: "Conta bancária",
		inputType: "text",
		initialValue: "07233-7",
	},
	pix_key: {
		name: "pix_key",
		label: "Chave PIX",
		inputType: "text",
		initialValue: "076.404.836-89",
	},
};
